import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const decorateControl = (Control, Decorator) => props => {
  const {
    children,
    decorator,
    help,
    input,
    legend,
    meta,
    ...extraProps
  } = props;
  const fieldProps = {
    ...input,
    ...extraProps,
    isField: true
  };
  return /*#__PURE__*/_jsx(Decorator, {
    ...props,
    children: /*#__PURE__*/_jsx(Control, {
      ...fieldProps,
      children: children
    })
  });
};
export default decorateControl;